import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DebtorServiceService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/Debtors/';

  insertdebtor(data:any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertdebtor', data)
  }

  getdebtor(id) {
    debugger
    return this.http.get(this.apiUrl + 'getdebtor?id='+id)
  }


  getdebtorLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'getdebtorLY?id=' + id)
  }
}
